import { loader } from '../components/_googlemaps.js';
import mapMarker from "../../img/static/map_marker.png";

document.addEventListener('alpine:init', () => {
    const projects_container = document.querySelector('div.projects__cards'),
        project_card = '.item__project';

    let Map, Marker, infoWindow;
    let markers = [];

    Alpine.data('centers', () => ({
        map: null,
        project_item: null,
        postal_code: null,
        
        async initMap() {
            loader.load().then((google) => {
                Map = google.maps;
                Marker = google.maps.Marker;

                this.map = new Map.Map(document.getElementById('map'), {
                    center: { lat: 51.2736153, lng: 4.108308 },
                    zoom: 9,
                    mapTypeControl: false,
                    mapTypeId: Map.MapTypeId.ROADMAP,
                    streetViewControl: false,
                    fullscreenControl: false,
                    styles: [
                        { "featureType": "administrative", "elementType": "all", "stylers": [{ "saturation": "-100" }] },
                        { "featureType": "administrative.province", "elementType": "all", "stylers": [{ "visibility": "off" }] },
                        { "featureType": "landscape", "elementType": "all", "stylers": [{ "saturation": -100 }, { "lightness": 65 }, { "visibility": "on" }] },
                        { "featureType": "poi", "elementType": "all", "stylers": [{ "saturation": -100 }, { "lightness": "50" }, { "visibility": "simplified" }] },
                        { "featureType": "road", "elementType": "all", "stylers": [{ "saturation": "-100" }] },
                        { "featureType": "road.highway", "elementType": "all", "stylers": [{ "visibility": "simplified" }] },
                        { "featureType": "road.arterial", "elementType": "all", "stylers": [{ "lightness": "30" }] },
                        { "featureType": "road.local", "elementType": "all", "stylers": [{ "lightness": "40" }] },
                        { "featureType": "transit", "elementType": "all", "stylers": [{ "saturation": -100 }, { "visibility": "simplified" }] },
                        { "featureType": "water", "elementType": "geometry", "stylers": [{ "hue": "#ffff00" }, { "lightness": -25 }, { "saturation": -97 }] },
                        { "featureType": "water", "elementType": "labels", "stylers": [{ "lightness": -25 }, { "saturation": -100 }] }
                    ]
                });

                infoWindow = new Map.InfoWindow();

                this.project_item = Array.from(document.querySelectorAll(project_card));
                this.project_item.forEach(target => {
                    let lat = target.getAttribute('data-lat'),
                        lng = target.getAttribute('data-lng'),
                        html = target.innerHTML,
                        iconUrl = target.getAttribute('data-icons') || mapMarker;

                    this.createMarker(new google.maps.LatLng(lat, lng), html, iconUrl);
                });

                google.maps.event.addListener(this.map, 'click', () => {
                    infoWindow.close();
                });

                this.init();
            })
            .catch((err) => {
                console.error("Error loading Google Maps API:", err);
            });
        },

        init() {
            document.addEventListener('keydown', (event) => {
                if (event.key === 'Enter') {
                    event.preventDefault();
                    this.handleFilter();
                }
            });

            document.addEventListener('change', (event) => {
                if (event.target && event.target.matches(".js-form_filter")) {
                    this.handleFilter();
                }
            });
        },

        reloadProjectsList() {
            this.project_item = Array.from(document.querySelectorAll(project_card));
        },

        removeCentersActiveClass() {
            this.project_item.forEach(node => {
                node.classList.remove('active');
            });
        },

        createMarker(latlng, html, iconUrl = mapMarker) {
            let marker = new Marker({
                position: latlng,
                icon: {
                    url: iconUrl,
                    scaledSize: new google.maps.Size(28, 40)
                },
                map: this.map
            });

            markers.push(marker);

            marker.addListener("click", () => {
                infoWindow.setContent(html);
                infoWindow.open(this.map, marker);

                this.removeCentersActiveClass();
            });

            return marker;
        },

        toggleMarker(i) {
            google.maps.event.trigger(markers[i], "click");
        },

        resetMarkers() {
            for (const marker of markers) {
                marker.setMap(null);
                google.maps.event.clearListeners(marker, "click");
            }

            markers = [];
        },

        fetchCenters() {
            let form = new FormData();
            form.append('action', 'get-centers-by-zip');
            form.append('postal_code', this.postal_code);
            let params = new URLSearchParams(form);

            fetch(urls.ajax, {
                method: 'POST',
                credentials: 'same-origin',
                headers: {
                    'Content-Type': 'application/x-www-form-urlencoded',
                    'Cache-Control': 'no-cache',
                },
                body: params
            }).then(response => {
                return response.json();
            }).then(response => {
                if (response.success) {
                    this.resetMarkers();

                    let locations = response.data.locations;
                    projects_container.innerHTML = '';

                    for (let i = 0; i < locations.length; i++) {
                        let tempDiv = document.createElement('div');
                        tempDiv.innerHTML = locations[i]['template'];
                        let target = tempDiv.firstChild;
                        projects_container.appendChild(target);

                        let lat = target.getAttribute('data-lat'),
                            lng = target.getAttribute('data-lng'),
                            html = target.innerHTML,
                            iconUrl = target.getAttribute('data-icons') || mapMarker;

                        this.createMarker(new google.maps.LatLng(lat, lng), html, iconUrl);
                    }

                    this.reloadProjectsList();
                    this.map.setCenter(markers[0]?.getPosition() || { lat: 50.8333432, lng: 4.3666294 });
                    projects_container.scrollTop = 0;
                }
            }).catch(err => {
                console.log(err);
            });
        },

        fetchGarageSchedules() {
            this.removeCentersActiveClass();

            let target = this.$el,
                parent = target.parentNode,
                index = [].indexOf.call(parent.children, target);

            target.classList.add('active');
            this.toggleMarker(index);
        },

        handleFilter() {
            let formData = new FormData(document.querySelector('.map-filter-form'));
            formData.append('action', 'filter-map');
            let params = new URLSearchParams(formData);

            fetch(urls.ajax, {
                method: 'POST',
                credentials: 'same-origin',
                headers: {
                    'Content-Type': 'application/x-www-form-urlencoded',
                    'Cache-Control': 'no-cache',
                },
                body: params
            }).then(response => {
                return response.json();
            }).then(response => {
                if (!response.success) {
                    console.log("error");
                } else {
                    projects_container.innerHTML = response.data.results;
                    document.querySelector('.search_results__count').innerHTML = response.data.total_results;

                    this.resetMarkers();
                    this.project_item = Array.from(document.querySelectorAll(project_card));
                    this.project_item.forEach(target => {
                        let lat = target.getAttribute('data-lat'),
                            lng = target.getAttribute('data-lng'),
                            html = target.innerHTML,
                            iconUrl = target.getAttribute('data-icons') || mapMarker;

                        this.createMarker(new google.maps.LatLng(lat, lng), html, iconUrl);
                    });
                }
            });
        },
    }));
});
